import CardActivationErrorScreen from 'features/cardManagement/screens/cardActivation/CardActivationErrorScreen/CardActivationErrorScreen';
import React from 'react';

export default function ChangePinPage() {
  return <CardActivationErrorScreen />;
}
